import React, { Fragment, useEffect, useState } from 'react';
import { ReactComponent as DealDetailsIcon } from 'assets/icons/post-details.svg';
import { ReactComponent as DealTimelineIcon } from 'assets/icons/post-timeline.svg';
import { ReactComponent as DealSettingsIcon } from 'assets/icons/deal-settings.svg';
import { Outlet, useNavigate } from 'react-router-dom';
import RightSidebar from 'components/right-sidebar';
import { ROUTE_KEYS } from 'utils/constants';
import useDashboardContext from 'contexts/dashboard.context';
import BottomNavigation from 'components/bottom-navigation';
import useCreateDealContext from 'contexts/create-deal.context';
import { apiService } from 'services/base.service';
import { toast } from 'react-toastify';
import { ToastMessage } from '@cokitchen/cokitchen-components';
import { handleApiError } from 'utils/functions';
import moment from 'moment';

const CreateDealContent = () => {
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const DealDetailsNav = [
    {
      title: 'Deal details',
      link: `${ROUTE_KEYS.CREATE_DEAL}/${ROUTE_KEYS.CREATE_DEAL_DETAILS}`,
      Icon: DealDetailsIcon
    },
    {
      title: 'Deal settings',
      link: `${ROUTE_KEYS.CREATE_DEAL}/${ROUTE_KEYS.CREATE_DEAL_SETTINGS}`,
      Icon: DealSettingsIcon
    },
    {
      title: 'Deal timeline',
      link: `${ROUTE_KEYS.CREATE_DEAL}/${ROUTE_KEYS.CREATE_DEAL_TIMELINE}`,
      Icon: DealTimelineIcon
    }
  ];
  const { setRightSection } = useDashboardContext();
  const { disabled, createDealForm, images } = useCreateDealContext();
  useEffect(() => {
    setRightSection(<RightSidebar title='Deal Information' list={DealDetailsNav} />);

    return () => {
      setRightSection(null);
    };
  }, []);

  const handleConfirm = async () => {
    try {
      setLoading(true);
      const payload = {
        ...createDealForm,
        images,
        item_type: 'FOOD',
        to_start_date: moment(createDealForm.to_start_date).format('YYYY-MM-DD'),
        to_start_time: `${createDealForm?.to_start_time?.timeWithColon}:00`,
        min_amount: createDealForm.min_amount || '0',
        min_items: createDealForm.min_items || '0',
        rate: createDealForm.rate || '0',
        fixed_amount: createDealForm.fixed_amount || '0',
        cap: createDealForm.cap ? Number(createDealForm.cap) : 0,
        ...(createDealForm.to_expire_date && {
          to_expire_date: moment(createDealForm.to_expire_date).format('YYYY-MM-DD')
        }),
        ...(createDealForm?.to_expire_time?.timeWithColon && {
          to_expire_time: `${createDealForm?.to_expire_time?.timeWithColon}:00`
        })
      };

      const res = await apiService.post('marketing/deal', {
        data: payload,
        isInternal: true
      });
      toast(<ToastMessage type='success' message={res.data.message} />);
      navigate(ROUTE_KEYS.DEALS_AND_DISCOUNTS);
    } catch (error) {
      handleApiError(error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Fragment>
      <Outlet />
      <div className='mx-10 pb-8 max-w-[700px]'>
        <BottomNavigation
          loading={loading}
          list={DealDetailsNav}
          onConfirm={handleConfirm}
          disabled={disabled}
        />
      </div>
    </Fragment>
  );
};

export default CreateDealContent;
